<!-- /首页  -->
<template>
  <div style='padding: 20px'>
    <div class="leftBox">
      <el-tabs :style="{ height: disposeData.organization_id == 0 ? '63vh' : '70vh' }" style="overflow: auto"
        tab-position="left" @tab-click="handleClick">
        <!--        <el-tab-pane label="logo">-->
        <!--          <ConfigLogo v-if="index == 0" :disposeData="disposeData"></ConfigLogo>-->
        <!--        </el-tab-pane>-->
        <el-tab-pane label="校徽">
          <ConfigSchoolBadge v-if="index == 0" :disposeData="disposeData"></ConfigSchoolBadge>
        </el-tab-pane>
        <!--        <el-tab-pane label="导航">-->
        <!--          <ConfigNav v-if="index == 2" :disposeData="disposeData"></ConfigNav>-->
        <!--        </el-tab-pane>-->
        <el-tab-pane label="Banner">
          <ConfigBanner v-if="index == 1" :disposeData="disposeData" :num="num"></ConfigBanner>
        </el-tab-pane>
        <el-tab-pane label="首页设置">


          <mechanism v-if="index == 2"></mechanism>

        </el-tab-pane>
        <el-tab-pane label="标题设置">


          <Homeset v-if='index == 3' :type="1"></Homeset>

        </el-tab-pane>
        <el-tab-pane label="课程设置">


          <courseset v-if='index == 4' :type="2"></courseset>

        </el-tab-pane>
        <el-tab-pane label="学校门户网站配置">

          <Dispose7></Dispose7>
          
        </el-tab-pane>




        <!--        <el-tab-pane label="数据统计">-->
        <!--          <ConfigStatistics-->
        <!--            v-if="index == 4"-->
        <!--            :disposeData="disposeData"-->
        <!--          ></ConfigStatistics>-->
        <!--        </el-tab-pane>-->
        <!--        <el-tab-pane label="院校精品资源">-->
        <!--          <ConfigResources-->
        <!--            v-if="index == 5"-->
        <!--            :disposeData="disposeData">-->
        <!--          </ConfigResources>-->
        <!--        </el-tab-pane>-->
        <!--        <el-tab-pane label="院校精品课程">-->
        <!--          <ConfigCurriculum-->
        <!--            v-if="index == 6"-->
        <!--            :disposeData="disposeData"-->
        <!--          ></ConfigCurriculum>-->
        <!--        </el-tab-pane>-->
        <!--        <el-tab-pane label="仿真实训方案">-->
        <!--          <ConfigTask  v-if="index == 7"-->
        <!--                       :disposeData="disposeData"></ConfigTask>-->
        <!--        </el-tab-pane>-->
        <!--        <el-tab-pane label="APP欢迎页">-->
        <!--          <ConfigAppWelcome  v-if="index == 8"-->
        <!--                             :disposeData="disposeData"></ConfigAppWelcome>-->
        <!--        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ConfigLogo from "./info/configLogo";
import Dispose7 from "./menhupeizhi/Dispose7";


// import ConfigStatistics from "./info/ConfigStatistics";
// import ConfigCurriculum from "./info/ConfigCurriculum";
import ConfigBanner from "./info/ConfigBanner";
// import ConfigResources from "./info/ConfigResources";
// import ConfigNav from "./info/ConfigNav";
// import ConfigTask from "./info/ConfigTask";
import ConfigSchoolBadge from './info/configSchoolBadge';
import mechanism from "./info/mechanism.vue";
import courseset from "./info/Homeset.vue"
import Homeset from "./info/Homeset.vue"
// import ConfigAppWelcome from './info/ConfigAppWelcome'
export default {
  name: "DisposeHome",
  components: {
    ConfigLogo,
    mechanism,
    courseset,
    Homeset,
    Dispose7,
    // ConfigStatistics,
    // ConfigCurriculum,
    ConfigBanner,
    // ConfigResources,
    // ConfigNav,
    // ConfigTask,
    ConfigSchoolBadge,
    // ConfigAppWelcome
  },
  props: {
    disposeData: Object,
  },
  data() {
    return {
      num: 3,
      index: 0,
      activeName: "first",
    };
  },
  mounted() {
    // console.log(77777777777777,this.disposeData);
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      this.index = tab.index;
    },
  },
};
</script>

<style >
/* .leftBox{ */
/* height: 650px; */
/* overflow:auto; */
/* } */
</style>
